import appConfig from '../reducers/appConfig'
import {IAppStore} from '../interfaces/reducers'
import {IPaylodAction, IActionDispatcher} from '../interfaces/dispatchers'

import {ConstrImportAction} from '../enums/ActionTypes/ConstrImportAction'
import Axios from 'axios'
import {appFeatureTablesDispatcher} from './appFeatureTablesDispatcher'
import {appSingleViewDispatcher} from './appSingleViewDispatcher'
import {
  IConstrInputData,
  IConstrConnectValidationData,
  IConstrImportActionData
} from '../interfaces/reducers/IConstrImport'

const unError = 'Възникна грешка! Опитайте пак и или се обърнете към администратор'
export const validate =
  () => (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
    const inputData = getStore().constrImport.inputData
    const formData = new FormData()
    formData.append('File', inputData.file!.file!, inputData.file!.name)
    formData.append('LocationId', JSON.stringify(inputData.location!.getProperties()['Id']))
    dispatch({
      type: ConstrImportAction.UPDATE_IMPORT_DATA,
      payload: {
        ...getStore().constrImport.inputData,
        loading: true,
        errors: [],
        startedImportGuid: '',
        expanded: false,
        errorDxf: undefined
      } as IConstrInputData
    })
    dispatch({
      type: ConstrImportAction.UPDATE_CONNECT_VALIDATE_DATA,
      payload: {
        ...getStore().constrImport.connectValidationData,
        loading: false,
        exists: false,
        successData: undefined
      } as IConstrConnectValidationData
    })
    dispatch({
      type: ConstrImportAction.UPDATE_IMPORT_ACTION_DATA,
      payload: {
        ...getStore().constrImport.connectValidationData,
        loading: false,
        success: false,
        errors: []
      } as IConstrImportActionData
    })
    Axios.post(`${appConfig.editsImport.validate}`, formData, {headers: {'Content-Type': `multipart/form-data;`}})
      .then(response => {
        if (response.data.SuccessDxf) {
          response.data.SuccessDxf = appConfig.urls.xyApiUrl + response.data.SuccessDxf
          dispatch({
            type: ConstrImportAction.UPDATE_CONNECT_VALIDATE_DATA,
            payload: {
              ...getStore().constrImport.connectValidationData,
              importPath: '',
              loading: false,
              exists: true,
              successData: {...response.data}
            } as IConstrConnectValidationData
          })
          dispatch({
            type: ConstrImportAction.UPDATE_IMPORT_DATA,
            payload: {
              ...getStore().constrImport.inputData,
              startedImportGuid: response.data['PATH'],
              loading: false
            } as IConstrInputData
          })
        } else {
          dispatch({
            type: ConstrImportAction.UPDATE_IMPORT_DATA,
            payload: {
              ...getStore().constrImport.inputData,
              loading: false,
              errors: response.data.Errors,
              errorDxf: response.data.ErrorsDxf
                ? appConfig.constrImport.constImportGetFileUrl + '/' + response.data.ErrorsDxf
                : ''
            } as IConstrInputData
          })
        }
      })
      .catch(e => {
        dispatch({
          type: ConstrImportAction.UPDATE_IMPORT_DATA,
          payload: {...getStore().constrImport.inputData, loading: false, errors: [unError]}
        })
      })
  }

export const importReg =
  (path: string) => (dispatch: (data: IPaylodAction | IActionDispatcher) => void, getStore: () => IAppStore) => {
    dispatch({
      type: ConstrImportAction.UPDATE_IMPORT_ACTION_DATA,
      payload: {...getStore().constrImport.connectValidationData, loading: true}
    })
    dispatch({
      type: ConstrImportAction.UPDATE_IMPORT_DATA,
      payload: {...getStore().constrImport.inputData, loading: true} as IConstrInputData
    })
    Axios.get(appConfig.editsImport.import + '/' + path)
      .then(() => {
        for (const id in getStore().layerInfos.featureLayerInfos) {
          getStore().layerInfos.featureLayerInfos[id].refresh()
        }
        const featureIds = Object.keys(getStore().data.featureTables)
        dispatch(appFeatureTablesDispatcher.setTablesVisibility({}))
        if (featureIds.length > 0) {
          dispatch(appFeatureTablesDispatcher.refrashTable(featureIds[0]))
        }
        dispatch({
          type: ConstrImportAction.UPDATE_IMPORT_ACTION_DATA,
          payload: {
            ...getStore().constrImport.connectValidationData,
            loading: false,
            success: true,
            errors: []
          } as IConstrImportActionData
        })
        dispatch({
          type: ConstrImportAction.UPDATE_IMPORT_DATA,
          payload: {...getStore().constrImport.inputData, loading: false} as IConstrInputData
        })
        dispatch(appSingleViewDispatcher.removeSelection())
      })
      .catch(e => {
        dispatch({
          type: ConstrImportAction.UPDATE_IMPORT_ACTION_DATA,
          payload: {
            ...getStore().constrImport.connectValidationData,
            loading: false,
            errors: [unError],
            success: false
          } as IConstrImportActionData
        })
        dispatch({
          type: ConstrImportAction.UPDATE_IMPORT_DATA,
          payload: {...getStore().constrImport.inputData, loading: false} as IConstrInputData
        })
      })
  }
